import React from 'react';
import { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import TextareaAutosize from 'react-textarea-autosize';
import toast, { Toaster } from 'react-hot-toast';
import ReactGA from "react-ga4";
import { Static } from './util.js';

import Offcanvas from 'react-bootstrap/Offcanvas';
import Carousel from 'react-bootstrap/Carousel';
import Button from 'react-bootstrap/Button';

import ImgLogo from './img/Logo.webp';




function Cresoul() {

    const store = useSelector((state) => state);

    let [fbModal, fbModalSet] = useState();
    let [msg, msgSet] = useState('');
    let [reply, replySet] = useState(false);
    let [email, emailSet] = useState('');
    let [sendable, sendableSet] = useState(false);

    const taRefMsg = useRef();

    const msgLengthMax = 1000;


    useEffect(() => {




    }, [])

    useEffect(() => {

        if (msg == '') {
            sendableSet(false);
        }
        else if (msg.length > msgLengthMax) {
            sendableSet(false);
        }
        else {
            sendableSet(true);
        }

    }, [msg])


    function AppSlot(title, sub, icon, img1, img2, img3, aos, ios) {

        return (

            <div className='my-5'>
                <div className="card rounded-0">
                    {/* <img src='https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/35/58/6e/35586ef4-5615-5e16-5e99-0406d87331bd/pr_source.png/313x0w.webp' alt="..."></img> */}
                    <Carousel>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={img1}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={img2}
                                alt="First slide"
                            />
                        </Carousel.Item>
                        <Carousel.Item>
                            <img
                                className="d-block w-100"
                                src={img3}
                                alt="First slide"
                            />
                        </Carousel.Item>
                    </Carousel>
                    <div className="card-body">
                        <img className='rounded-5 mb-2'
                            src={icon}
                            style={{ height: 80 }}
                            alt="..."></img>
                        <h2 className="card-title"><b>{title}</b></h2>
                        <p className="card-text text-body-tertiary">{sub}</p>
                        <button className="btn btn-primary rounded-pill p-3 px-5" onClick={() => {
                            ClickMore(title, aos, ios);

                        }}>
                            더 보기 <i className="fi-rr-play-circle va-m"></i>
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    function SendFeedback() {
        fbModalSet(false);

        axios.post(Static.SvrAddr + 'addfeedback', {
            msg: msg,
            email: email,
            user: localStorage.getItem('uuid'),
        }).then((res) => {
            msgSet('');
            toast.success('메세지를 보냈어요.');
        }).catch(() => {
            console.log('실패함');
        })
    }


    function ClickMore(title, aos, ios) {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        let os = '';
        if (/android/i.test(userAgent)) {
            os = 'AOS';
            window.open(aos, '_blank');
        } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            os = 'iOS';
            window.open(ios, '_blank');
        } else if (/windows phone/i.test(userAgent)) {
            os = 'winP';
            window.open(aos, '_blank');
        } else {
            os = 'Other';
            console.log("Other OS");
            window.open(aos, '_blank');
        }

        ReactGA.event('click_appmore', { 'title': title, 'os': os });
    }

    return (
        <>
            <div className='bg-body-tertiary rounded-4 p-4'>
                <div className='text-body-tertiary' style={{ fontSize: '5em' }}>
                    <i className="fi-rr-message-quote va-m"></i>
                </div>
                <div className='fs-6'>
                    문의사항이나 더 나은 서비스를 위한 아이디어가 있나요? 저희에게 알려주세요!
                </div>
                <button onClick={() => { replySet(false); fbModalSet(true) }} className="btn btn-primary rounded-pill m-2 p-3 px-5">
                    메세지 작성 <i className="fi-rr-paper-plane va-m"></i>
                </button>
            </div>


            <div className='my-5'>
                <div className='fs-6 mt-5'>
                    저희가 만든 모바일 게임도 있어요.<br></br>
                    새로운 재미를 발견해 보세요!
                </div>
                {AppSlot('이심전심 취향궁합테스트', '실시간으로 진행되는 온라인 커플 밸런스 게임',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/89/9d/a2/899da23d-e9de-05b4-5643-8cafbff863f3/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/146x0w.webp',
                    "https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/35/58/6e/35586ef4-5615-5e16-5e99-0406d87331bd/pr_source.png/313x0w.webp",
                    "https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/2e/31/59/2e315901-66d9-2efd-fa00-d5dcf657972a/pr_source.png/313x0w.webp",
                    "https://is1-ssl.mzstatic.com/image/thumb/Purple124/v4/12/fd/9c/12fd9c2f-6ade-6eb4-3738-7da5b92878cf/pr_source.png/313x0w.webp",
                    'https://play.google.com/store/apps/details?id=com.cresoul.match',
                    'https://apps.apple.com/kr/app/%EC%9D%B4%EC%8B%AC%EC%A0%84%EC%8B%AC-%EC%B7%A8%ED%96%A5-%EA%B6%81%ED%95%A9-%ED%85%8C%EC%8A%A4%ED%8A%B8/id1475848502'
                )}
                {AppSlot('취향 월드컵', '빅데이터로 알아보는 내 취향 타입',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/ab/28/ed/ab28ed32-a691-4d7a-f342-7966309f98cd/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/e3/dd/2d/e3dd2db1-996b-ea61-aa0f-47349509343a/b7f4cdc8-0257-4928-82e2-02aec206c95e_2048x2732_027_0000.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource114/v4/61/59/93/615993e6-0336-9d66-0711-a4a5c0da05ca/9ff695ae-f871-4e75-b97f-5efa7125ab69_2048x2732_025_0000.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple114/v4/f8/a8/29/f8a82936-afbe-fa3a-1a39-a99d756108a9/ff8a5104-64ef-404c-9e70-af07de2f1e8f_2048x2732_024_0000.png/313x0w.webp',
                    'https://play.google.com/store/apps/details?id=com.cresoul.wc',
                    'https://apps.apple.com/kr/app/%EC%B7%A8%ED%96%A5-%EC%9B%94%EB%93%9C%EC%BB%B5-%EC%9D%B4%EC%83%81%ED%98%95-%EC%9B%94%EB%93%9C%EC%BB%B5/id1547423685'
                )}
                {AppSlot('AI 그림퀴즈', '아재 개그 퀴즈를 맞추는 새로운 퍼즐 퀴즈 게임',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/c1/44/19/c1441972-b4a3-20e2-d7d3-60e19e9a9a6f/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp',
                    'https://play-lh.googleusercontent.com/OpTDcJ74UosTJdqg-qnEuaZpTlRn0gEZR_yvsEeT70Ne05a_EHEPS0NDm_QcmVWG5zE=w526-h296-rw',
                    'https://play-lh.googleusercontent.com/6mANacQl0wiGIjm22kicLD8DPDvSMJrkrk1vkWPN4tn3PxYe27HvJt7s1juoc2kqJ6IN=w526-h296-rw',
                    'https://play-lh.googleusercontent.com/RWbgeWD9AsIfCfl1SMLEYqGPVNVVhVWKLLnnjoScro-XYJ5AX-9wNVRY7Qo_AVBqTRA=w526-h296-rw',
                    'https://play.google.com/store/apps/details?id=com.cresoul.aq',
                    'https://apps.apple.com/kr/app/%EB%8B%88%EB%8F%84%EC%95%84%EC%9E%AC%EB%8B%88-ai-%EA%B7%B8%EB%A6%BC%ED%80%B4%EC%A6%88/id6446777725'
                )}
                {AppSlot('퀴즈잇다', '자음과 모음을 이어 정답을 맞추는 신개념 퍼즐 퀴즈 게임',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/bf/96/55/bf9655fa-02b1-79b2-e328-c05b6839bda4/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple116/v4/89/df/81/89df8197-a8f7-ae65-1755-8a3456131cd5/6641a572-f9a6-4603-b3c2-d34b25eec59a_2048x2732_007_0006.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/6d/e0/be/6de0beb3-6663-1ac4-6d52-482a14cccae1/b073f157-4214-4b14-b64f-4e79b927bcdf_2048x2732_008_0004.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource126/v4/23/b9/bd/23b9bd21-eb06-3e60-b369-871bdc43f257/b83fd5e9-f8db-4357-82c9-8c8445d8f932_IOS_IPAD_2048x2732_4.png/313x0w.webp',
                    'https://play.google.com/store/apps/details?id=com.cresoul.hp',
                    'https://apps.apple.com/kr/app/%ED%80%B4%EC%A6%88%EC%9E%87%EB%8B%A4/id1663923084'
                )}
                {AppSlot('그려라! 용사 (RPG)', '픽셀을 모아 나만의 용사로 배틀',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/ff/ce/b5/ffceb5c4-43d0-64b4-359b-958d391f53d1/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/230x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/1c/49/90/1c4990c2-189f-ca60-1f54-6bff14b1edd4/pr_source.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/39/15/35/391535ee-baec-a895-4a76-c6dd35f605de/pr_source.png/313x0w.webp',
                    'https://is1-ssl.mzstatic.com/image/thumb/Purple123/v4/a5/5b/1d/a55b1d00-f993-49e5-ec8c-e18595a44d54/pr_source.png/313x0w.webp',
                    'https://play.google.com/store/apps/details?id=com.cresoul',
                    'https://apps.apple.com/kr/app/draw-knight-rpg/id1291784748'
                )}
                {AppSlot('무궁화 꽃이 피었습니다', '상금을 위해 목숨을 건 서바이벌 게임',
                    'https://play-lh.googleusercontent.com/jgPWh3B-Oay5AEMaEytttValvgEY-_ArLBBgPLx4tAQ1fC99w_8idakRL9MpNf4p7ik=w240-h480-rw',
                    'https://play-lh.googleusercontent.com/6S2_NhvV5XkSJPXEbY_ZNoBIXOmaJr51SJ7hR7YvP5jCQSyAK31XJoEFM3eabesiTgJf=w526-h296-rw',
                    'https://play-lh.googleusercontent.com/_xAX0e6tFVtP0RLJqGBfBVOusL3Z4mdrzWthFfZ-R_KVUA8hH8TmprnRdE8s8XbsdtY=w526-h296-rw',
                    'https://play-lh.googleusercontent.com/faPBqipljQHd4JIzsgU_flU-qraymjDJhSNsXxOfQfduCvgbHwRIZvWtXtKM58VZiYw=w526-h296-rw',
                    'https://play.google.com/store/apps/details?id=com.cresoul.sg2',
                    'https://play.google.com/store/apps/details?id=com.cresoul.sg2'
                )}

            </div>


            <div className='bg-body-tertiary rounded-4 p-4 my-4'>
                <div className='text-body-tertiary' style={{ fontSize: '5em' }}>
                    <i className="fi-rr-blog-text va-m"></i>
                </div>
                <div className='fs-6'>
                    활용 팁과 게임 주제들을 모아 놓은 밸궁 블로그를 방문해 보세요!
                </div>
                <button onClick={() => {
                    window.open('https://blog.belgung.com', '_blank');
                    ReactGA.event('click_appmore', { 'title': '블로그', 'os': 'null' });
                }} className="btn btn-primary rounded-pill m-2 p-3 px-5">
                    블로그 보러가기 <i className="fi-rr-angle-small-right va-m"></i>
                </button>
            </div>


            <Offcanvas show={fbModal} onHide={() => { fbModalSet(false) }} placement='bottom' style={{ height: '280px' }}>
                <Offcanvas.Body >
                    <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2' minRows={4} maxRows={4}
                        placeholder="메세지 입력" value={msg} style={{ width: '100%' }} ref={taRefMsg}
                        onChange={(e) => { msgSet(e.target.value) }} />

                    <div class="mb-3">
                        <label>
                            <input style={{ width: '20px', height: '20px' }}
                                className='form-check-input va-m m-1'
                                type='checkbox'
                                onChange={(e) => { replySet(e.target.checked) }} />
                            답장을 원해요
                        </label>
                        <input type="email" class="form-control" disabled={!reply} placeholder="example@email.com" onChange={(e) => { emailSet(e.target.value) }}></input>
                    </div>

                    <div className='d-flex justify-content-end align-items-center'>
                        <span className={sendable ? ('') : ('text-danger')}>
                            {msg.length}
                        </span>
                        /{msgLengthMax}
                        <Button className='ms-3' variant="primary" disabled={!sendable} onClick={() => { SendFeedback() }}>
                            보내기 <i class="fi-rr-check-circle va-m"></i>
                        </Button>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>

            <Toaster />

        </>
    )
}

export default Cresoul;
